module.exports = __webpack_public_path__ + "static/media/covid-rider-marker.1ce2cbe9.svg";